import React from 'react';

const LogoSvg = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.0004 0C18.8318 6.04207 23.9629 11.1772 30 15.0114C23.9706 18.8408 18.8449 23.9679 15.0151 30H0C8.277 30 14.9868 23.2843 14.9868 15C14.9868 6.71573 8.277 0 0 0H15.0004Z" fill="white"/>
  </svg>
);

export default LogoSvg;